import angular from 'angular';

import ColorPaletteComponent from './color-palette.cmpt';

export default angular
    .module('application.component.modals.component.category-edit-modal.component.color-palette', [])
    .component(ColorPaletteComponent.selector, ColorPaletteComponent);



// WEBPACK FOOTER //
// ./src/application/component/modals/component/category-edit-modal/component/color-palette/index.js